import { h } from 'vue'
import OrganismHero from '~/components/organisms/hero/hero.vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const Functional = (props) => {
  return h(UiComponentWrapper, { class: 'text-content' }, () => [
    h(UiComponentContainer, {}, () => [
      h(OrganismHero, {
        class: 'content-header',
        alignment: 'left',
        level: 2,
        primaryButton: props.record.callToAction,
      }, {
        heading: () => props.record.heading,
        paragraph: () => props.record.paragraph,
        tag: () => (props.record.tag === '' ? undefined : props.record.tag),
      }),
    ]),
  ])
}

Functional.props = {
  record: {
    required: true,
    type: Object,
  },
}

export default Functional
